import Icon from '@material-ui/icons/Phone';
import React from 'react';
import { CreateButton } from '../../buttons';
import { EditDialog, Filter, ResourceList } from '../../controllers';
import { NumberField, TextField } from '../../fields';
import { BooleanInput, SearchInput, TextInput } from '../../inputs';





export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextField
          source="name"
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        {...props}
      >
        <TextInput
          source="name"
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <NumberField
          source="calls_in_queue"
        />
        <NumberField
          source="average_wait_time"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <SearchInput
          label="Search"
          source="q"
        />
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
